module.exports = __webpack_public_path__ + "img/rivet_svg_p2983k.2999fc41.svg";